module.exports = __webpack_public_path__ + "static/media/asset21.bc46e716.jpg";